<template>
  <button type="button" class="bwauth-ghost-button" @click="$emit('input', !value)">
    <img :src="value ? eyeIconSrc : eyeOffIconSrc" :alt="value ? $t('Hide') : $t('Show')">
  </button>
</template>

<script>
import eyeIcon from './icons/eye.svg';
import eyeOffIcon from './icons/eye-off.svg';

export default {
  name: 'PasswordToggle',
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    eyeIconSrc() {
      return eyeIcon.default || eyeIcon;
    },
    eyeOffIconSrc() {
      return eyeOffIcon.default || eyeOffIcon;
    },
  },
};
</script>
